import { render, staticRenderFns } from "./IdEditor.vue?vue&type=template&id=ec831364&scoped=true"
import script from "./IdEditor.vue?vue&type=script&lang=js"
export * from "./IdEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec831364",
  null
  
)

export default component.exports